import { z } from 'zod';
import type { projectPathObj } from '../models/pinpoint-path';

export const KsInvestmentBasicInformationScenePinpointFieldEnum = z.enum([
  'ks.investment.organization-in-charge',
  'ks.investment.people-in-charge',
  'ks.investment.business-manager',
  'ks.investment.other-organization-in-charge',
  'ks.investment.related-organizations',
  'ks.investment.project-number',
  'ks.investment.project-group',
  'ks.investment.fund-sheet-type',
  'ks.investment.fund-sheet-number',
  'ks.investment.fund-sheet-branch-number',
  'ks.investment.corporate-name',
  'ks.investment.period',
  'ks.investment.overview',
  'ks.investment.remark',
  'ks.investment.old-project-number',
  'ks.investment.project-reference',
  'ks.investment.legal-basis',
  'ks.investment.beneficiary-info',
  'ks.investment.related-project-for-other-ministry',
]);

export const KsInvestmentFundInvestmentsScenePinpointFieldEnum = z.enum([
  'ks.investment.accumulated-amount-table',
  'ks.investment.accumulated-amount-from-the-government-table',
]);

export const KsInvestmentFundBusinessScenePinpointFieldEnum = z.enum([
  'ks.investment.fund-business-regarding',
]);

export const KsInvestmentRelatedMaterialScenePinpointFieldEnum = z.enum([
  'ks.investment.related-material-image',
  'ks.investment.related-material-remark',
]);

export const KsInvestmentPinpointFieldEnum = z.enum([
  ...KsInvestmentBasicInformationScenePinpointFieldEnum.options,
  ...KsInvestmentFundInvestmentsScenePinpointFieldEnum.options,
  ...KsInvestmentFundBusinessScenePinpointFieldEnum.options,
  ...KsInvestmentRelatedMaterialScenePinpointFieldEnum.options,
]);

type ProjectPinpointMappingType = {
  path: z.infer<typeof projectPathObj>;
  field:
    | z.infer<typeof KsInvestmentBasicInformationScenePinpointFieldEnum>
    | z.infer<typeof KsInvestmentFundInvestmentsScenePinpointFieldEnum>
    | z.infer<typeof KsInvestmentFundBusinessScenePinpointFieldEnum>
    | z.infer<typeof KsInvestmentRelatedMaterialScenePinpointFieldEnum>;
};

export type KsInvestmentPinpointMappingType = ProjectPinpointMappingType;
